export const UriConfiguration = () => {
    let baseURL = 'https://voicebotapi.iassoftware.co';
    //let baseURL = "http://localhost:8080";
    //let baseURL = 'http://3.215.58.103:8080';
    return baseURL;
}